// extracted by mini-css-extract-plugin
export var defaultWrapper = "_hl-3";
export var downloadButton = "_hl-4";
export var fileContainer = "_hl-9 _hl-7";
export var fileContainerBase = "_hl-7";
export var fileContainerBaseSm = "_hl-a _hl-7";
export var fileContainerFixedHeight = "_hl-8 _hl-7";
export var fileContainerFixedHeightSm = "_hl-c _hl-a _hl-7";
export var fileContainerSm = "_hl-b _hl-a _hl-7";
export var fileInfo = "_hl-5";
export var fileInfoWidthRestricted = "_hl-6";
export var fileType = "_hl-1";
export var fileTypeName = "_hl-2";
export var fileTypeSm = "_hl-d _hl-1";
export var image = "_hl-0";
export var link = "_hl-f";
export var overflowEllipsis = "_hl-e";